export default __webpack_public_path__ + "static/media/fruitjelly@2x.e2ce1667.jpg";